import {
	Checkbox,
	FormItem,
	ValidationError
} from "client/Components";
import { UsersAndUserGroupsDataModel } from "client/Api/UserGroupsManagement/userGroupsManagement";
import { attachToUserAndUserGroupCollection } from "client/Features/Users/UserAndUserGroupCollection/attachable";
import {
	UserAndUserGroupCollection,
	UserAndUserGroupKind
} from "client/Features/Users/UserAndUserGroupCollection/UserAndUserGroupCollection";
import { ActiveTab } from "client/Features/Users/UserAndUserGroupTabSelector/UserAndUserGroupTabSelector";
import { IObjectInputAttachable } from "client/Forms/attachable";
import { ReactElement } from "react";
import { localize } from "client_legacy/ndaw/culture";
import { HubItemComposerDialog } from "../../HubItemComposerDialog/HubItemComposerDialog";
import { KnowledgeItemSaveModel, KnowledgeItemStatus } from "client/Api/KnowledgeItemManagement/knowledgeItemManagement";

const {
	Title,
	Step,
	Content,
	FormContainer
} = HubItemComposerDialog;

export type WhoHasAccessStepProps = {
	isActive: boolean;
	attachable: IObjectInputAttachable<KnowledgeItemSaveModel>;
	status: KnowledgeItemStatus;
	usersAndUserGroupsData: UsersAndUserGroupsDataModel;
	infoAlerts?: ReactElement;
};

export const WhoHasAccessStep = (props: WhoHasAccessStepProps): ReactElement => {
	const {
		isActive,
		attachable,
		status,
		usersAndUserGroupsData,
		infoAlerts
	} = props;

	const isArchived: boolean = status === KnowledgeItemStatus.Archived;

	return (
		<Step
			trackingId="who-has-access-step"
			isActive={isActive}
		>
			<Content stretchHeight>
				{infoAlerts}
				<FormContainer>
					<Title text={localize("_WhoHasAccess")} />
					<FormItem>
						<Checkbox
							{...attachable.for("isForEveryoneInTheCategory").attachToCheckbox()}
							text={localize("_EveryoneWhoHasAccessToTheCategory")}
							isDisabled={isArchived}
						/>
						<ValidationError {...attachable.for("isForEveryoneInTheCategory").attachToValidationError()} />
					</FormItem>
				</FormContainer>
				<UserAndUserGroupCollection
					{...attachToUserAndUserGroupCollection(
						attachable.for("access"),
						isArchived
							? {
								kind: UserAndUserGroupKind.Read
							}
							: {
								kind: UserAndUserGroupKind.Edit,
								dialogTitleWhenAddingUsersAndUserGroups: localize("_AddGroupsOrUsers")
							}
					)}
					activeTab={ActiveTab.UserGroup}
					allUsersAndUserGroupsData={usersAndUserGroupsData}
				/>
			</Content>
		</Step>
	);
};
WhoHasAccessStep.displayName = "WhoHasAccessStep";